import { mapMutations } from 'vuex';

export default {
	data() {
		return {
			appPosition: this.$route.query.position || '',
		};
	},
	methods: {
		...mapMutations('welfare/task', [
			'setTaskList',
			'setWallet',
			'setSignInfo',
			'setRegressTaskList',
			'setOverBusinessName',
			'setTreasureBox',
			'setTreasureTaskList',
			'setCoinRatePromote',
		]),
		/**
		 * @description: 获取福利页面数据
		 * return void
		 */

		getPageInfo() {
			this.$post(this.$api.GET_WELFARE_TASK_PAGE_INFO_API).then((res) => {
				const { data } = res;
				this.setSignInfo(data);
				this.setRegressTaskList(data);
				this.setTaskList(data);
				this.setOverBusinessName(data);

				// 金币汇率信息
				if (data.coin_rate_promote) {
					this.setCoinRatePromote(data.coin_rate_promote);
				}

				const { task_list_new, chest_task } = data;

				if (chest_task) {
					const { chest, task } = chest_task;
					this.setTreasureBox(chest);
					this.setTreasureTaskList(task);
				} else {
					this.setTreasureBox(null);
					this.setTreasureTaskList([]);
				}

				// 对待领取任务进行埋点
				let waitTrackTaskList = [];

				if (task_list_new) {
					for (let i = task_list_new.length - 1; i >= 0; i--) {
						if (task_list_new[i].task_list && task_list_new[i].task_list.length) {
							let filterAry = task_list_new[i].task_list.filter((task) => {
								return +task.progress_status === 1;
							});
							waitTrackTaskList = waitTrackTaskList.concat(filterAry);
						}
					}
				}

				waitTrackTaskList.forEach((item) => {
					this.$root.trackClick({
						page_title: '福利任务页',
						element_name: '任务列表_待领取曝光',
						remarks: `${item.task_id};${item.title}`,
					});
				});
			}).catch((e) => {});
		},

		/**
		 * @description: 获取福利页面钱包数据
		 * return void
		 */

		getWalletInfo() {
			return new Promise((resolve, reject) => {
				this.$post(this.$api.GET_WALLET_API)
					.then((res) => {
						const { data } = res;
						this.setWallet(data);
						resolve();
					})
					.catch((e) => {
						reject(e)
					});
			});
		},
	},
};



// WEBPACK FOOTER //
// ./src/mixins/WelfareTaskMixin.js